import { render, staticRenderFns } from "./SelfServiceZlj.vue?vue&type=template&id=4135d4b0&scoped=true"
import script from "./SelfServiceZlj.vue?vue&type=script&lang=js"
export * from "./SelfServiceZlj.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceZlj.vue?vue&type=style&index=0&id=4135d4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135d4b0",
  null
  
)

export default component.exports